<template>
    <v-app>
        <v-main>
            <div class="opacity-background"/>
            <v-container fluid
                         class="background fill-height d-flex justify-center"
                         :style="{ backgroundImage: `url(${authLogoAndImage.background})` }">
                <div style="position: absolute; right: 20px; top: 20px">
                    <Language outlined icon/>
                </div>
                <v-row align="center" justify="center" class="mb-8">
                    <v-col cols="12" style="max-width: 400px;">
                        <div class="sign-card">
                            <div class="pa-0 d-flex justify-center">
                                <v-img class="mt-4"
                                       :src="authLogoAndImage.logo"
                                       style="max-width: 125px"/>
                            </div>

                            <div class="px-5">
                                <v-row>
                                    <component :is="section"
                                               @changeSection="changeSection($event)"
                                               @closeModal="$emit('closeModal')"
                                               @emailReset="emailReset($event)"/>
                                </v-row>
                            </div>

                            <div class="access-account-text-container"
                                 :class="{'cloudtask-bottom-position': isCloudTask}"
                                 v-if="section === 'keybeLogin'">
                              <span style="color: white; font-size: 14px;">
                                {{ $t('login.newHere') }}
                                <span class="ml-2 text-uppercase"
                                      @click="changeSection('keybeRegister')"
                                      style="color: #11CDEF; cursor: pointer; font-weight: 700; font-size: 14px;">
                                  {{ $t('login.openAccount') }}
                                </span>
                              </span>
                            </div>

                            <div class="access-account-text-container mt-2"
                                 v-else-if="section === 'keybeRegister'">
                              <span style="color: white; font-size: 14px">
                                {{ $t('login.haveAccount') }}
                                <span class="ml-2 text-uppercase"
                                      @click="changeSection('keybeLogin')"
                                      style="color: #11CDEF; cursor: pointer; font-weight: 700; font-size: 14px;">
                                  {{ $t('login.signIn') }}
                                </span>
                              </span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import KeybeNewPassword from '@/pages/Auth/NewPassword.vue'
import KeybeResetPassword from '@/pages/Auth/ResetPassword.vue'
import KeybeLogin from '@/pages/Auth/Login.vue'
import KeybeRegister from '@/pages/Auth/Register.vue'
import Language from '@/components/widgets/Language'
import { mapState } from 'vuex'

export default {
  components: { KeybeNewPassword, KeybeResetPassword, KeybeLogin, KeybeRegister, Language },
  computed: {
    authLogoAndImage () {
      if (this.isCloudTask) {
        return {
          logo: 'https://storage.googleapis.com/keybe/cloudtask/cloudtask-logo.svg',
          background: 'https://storage.googleapis.com/keybe/cloudtask/cloustask-background.jpg'
        }
      }
      return {
        logo: 'https://storage.googleapis.com/keybe/images/kb-logos/keybe-light.svg',
        background: 'https://storage.googleapis.com/keybe/app/images/keybe-happy-face-background.jpg'
      }
    },
    ...mapState({
      isCloudTask: state => state.auth.isCloudTask
    })
  },
  created () {
    if (this.$route.query.invitation) {
      this.changeSection('keybeRegister')
    }
    this.checkIfCloudTask()
  },
  data () {
    return {
      section: 'keybeLogin'
    }
  },
  methods: {
    changeSection (value) {
      this.section = value
    },
    checkIfCloudTask () {
      if (window.location.href.includes('cloudtask.com')) {
        this.$store.commit('SET_CLOUDTASK', true)
      } else {
        this.$store.commit('SET_CLOUDTASK', false)
      }
    }
  }
}
</script>

<style scoped>
    .background {
        background-repeat: no-repeat;
        background-position: center center;
        background-attachment: fixed;
        background-size: cover;
        overflow-y: hidden;
    }
    div.opacity-background {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
    }
    .sign-card {
        position: relative;
        background-color: #F7FAFC;
        border-radius: 10px;
    }
    div.access-account-text-container {
        position: absolute;
        bottom: -40px;
        left: 0;
        width: 100%;
        text-align: center;
    }
</style>
